export const Box = {
  variants: {
    navBar: {
      bg: 'red',
      color: 'blue',
    },
  },
};

//sx={{ position: 'sticky', top: '0', width: '100%', backgroundColor: '' }}
